import type { SVGProps } from 'react';

const SvgCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill='none'
    height={10}
    viewBox='0 0 12 10'
    width={12}
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M10.318.771a.96.96 0 0 1 1.524 1.16l-.08.103-6.288 7.195a.96.96 0 0 1-1.298.137l-.103-.09L.28 5.484a.959.959 0 0 1 1.25-1.45l.108.093L4.704 7.19z'
      fill='currentColor'
    />
  </svg>
);
export default SvgCheck;
